import { Formik } from 'formik'
import { unwrapResult } from '@reduxjs/toolkit'
import React from 'react'
import * as Yup from 'yup'

import {
  Button,
  Form,
  FormikTextField,
  FIELD_REQUIRED,
  FormikCheckbox,
} from 'src/modules/ui'
import { FormActions } from 'src/modules/auth'
import { useActionRunner } from 'src/modules/notification'

import { useAuth } from '../hooks'

const ProfileForm = () => {
  const { user, updateProfile } = useAuth()
  const initialValues = {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    notificationOptIn: user.notificationOptIn,
  }

  const [doUpdateProfile] = useActionRunner(updateProfile, {
    successNotification: 'Profile Updated!',
  })

  const handleSubmit = async (values, { setErrors }) => {
    try {
      const result = await doUpdateProfile(values)
      unwrapResult(result)
    } catch (error) {
      setErrors(error.data)
    }
  }

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required(FIELD_REQUIRED),
    lastName: Yup.string().required(FIELD_REQUIRED),
    email: Yup.string().email().required(FIELD_REQUIRED),
    notificationOptIn: Yup.boolean(),
  })

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, isSubmitting, errors }) => (
        <>
          <Form>
            <Form.InputGroup title="Profile">
              <FormikTextField
                fullWidth
                label="First Name"
                margin="normal"
                name="firstName"
                type="text"
              />
              <FormikTextField
                fullWidth
                label="Last Name"
                margin="normal"
                name="lastName"
                type="text"
              />
              <FormikTextField
                fullWidth
                label="Email"
                margin="normal"
                name="email"
                type="email"
              />
              <FormikCheckbox
                label="Do you want to receive notifications?"
                name="notificationOptIn"
                value={user.notificationOtIn}
              />
            </Form.InputGroup>
            <FormActions>
              <Button
                color="primary"
                onClick={handleSubmit}
                isLoading={isSubmitting}
                size="large"
                type="submit"
              >
                Update Profile
              </Button>
            </FormActions>
          </Form>
        </>
      )}
    </Formik>
  )
}

export default ProfileForm
